<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Pré Visualização"
    type-modal="print_warranty_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="print()">
        <d-form-row>
          <!-- Receipt Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem do recibo</label>
            <editor ref="recibo" :model.sync="model.receipt"/>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Guaranty Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem da Garantia</label>
            <editor ref="warranty" :model.sync="model.warranty"/>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- approbation Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem da Vistoria</label>
            <editor ref="approbation" :model.sync="model.approbation"/>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Footer Message -->
          <d-col md="12" class="form-group">
            <label for="feInputFooter">Mensagem Rodapé</label>
            <d-form-input type="text" id="feInputFooter" v-model="model.footer" />
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Imprimir</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinFormatMessage from '_common/mixins/FormatMessage';
import { openPdf, catchPdf } from '_utils/require';
import { _OPEN_MODAL_, MODEL } from '../QuotationModel';
import { MESSAGES, SETTINGS, _LOAD_MODEL_SETTING_ } from '../../../settings/components/SettingsModel';

export default {
  name: 'print-warrant',
  data() {
    return {
      loading: false,
      model: { ...MESSAGES },
      quotation: { ...MODEL },
    };
  },
  mixins: [MixinFormatMessage],
  components: {
    Editor,
    ModalTemplate,
  },
  computed: {
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        return messages;
      }
      return { ...MESSAGES };
    },
    settings() {
      const { settings } = this.$store.state.settings;
      if (settings) {
        Events.$emit(_LOAD_MODEL_SETTING_, settings);
        return settings;
      }
      return { ...SETTINGS };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSettings',
      'activeAlert',
    ]),
    formatApprobation() {
      const message = this.setCustomerMessage(this.messages.approbation, this.quotation.customer);
      this.model.approbation = message;
    },
    formatMessages() {
      this.model = { ...this.messages };
      this.formatReceipt();
      this.formatWarranty();
      this.formatApprobation();
    },
    formatReceipt() {
      let { receipt } = this.messages;
      receipt = this.setCustomerMessage(receipt, this.quotation.customer);
      receipt = this.setQuotationMessage(receipt, this.quotation);
      this.model.receipt = receipt;
    },
    formatWarranty() {
      this.model.warranty = this.messages.warranty.replace('{{garantia}}', this.settings.warranty);
    },
    getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSettings()
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.setToggle({ type: 'progress', bool: true });
      const params = { messages: this.model, quotation: this.quotation };
      QuotationService.printWarranty(params)
        .then(response => {
          openPdf(response);
          this.setToggle({ type: 'print_warranty_modal', bool: false });
        })
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'print_warranty_modal') {
        this.quotation = quotation;
        if (this.quotation) {
          this.formatMessages();
        }
      }
    });
    if (this.$store.state.settings.messages == null) {
      this.getSettingsSystem();
    }
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
      max-width: 1100px;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
